import { render } from "./IconFavoriteRibbon.vue?vue&type=template&id=33791df9"
const script = {}

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__